import { render, staticRenderFns } from "./AboutObj9527.vue?vue&type=template&id=45da227d&"
import script from "./AboutObj9527.vue?vue&type=script&lang=js&"
export * from "./AboutObj9527.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports